export const CUPONERA_SEATS_BEGIN = 'CUPONERA_SEATS_BEGIN';
export const CUPONERA_SEATS_SUCCESS = 'CUPONERA_SEATS_SUCCESS';
export const CUPONERA_SEATS_FAILURE = 'CUPONERA_SEATS_FAILURE';
//
export const SELECT_CUPONERA = 'SELECT_CUPONERA';



// WEBPACK FOOTER //
// ./src/features/cuponera/redux/constants.js